var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMissingE = function SvgMissingE(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 410 164"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E62B1E",
    d: "M43 54H2V16h127v38H88v109H43zm268.976 71 18.584.126c28.145 0 32.259-22.814 32.259-36.595 0-9.233-3.187-34.531-35.851-34.531h-14.992zM267 16h74.858C390.731 16 408 52.172 408 89.15c0 45.022-23.819 73.85-74.968 73.85H267z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#CCC",
    strokeDasharray: "4,6",
    d: "M136 16h124v38h-78v18h78v35h-78v18h78v38H136z"
  })));
};
export default SvgMissingE;